import { useEffect, useRef } from "react";

export const useClickAwayCloseInModal = ( elementShowing: boolean, popoutRef: React.RefObject<HTMLElement | null>, onHideElement: () => void) => {
    const justOpenedRef = useRef(false);

    //this is to handle weirdness around opening the pop out to start
    // fixes race conditions
    useEffect(() => {
        if (elementShowing) {
            justOpenedRef.current = true;
            const timeoutId = setTimeout(() => {
                justOpenedRef.current = false;
            }, 0);

            return () => clearTimeout(timeoutId);
        }
    }, [elementShowing]);

    //will hide the element if the user clicks outside modal, or modal in modals.
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {

            if (!elementShowing || justOpenedRef.current) return;

            const target = event.target as Node;

            if (popoutRef.current?.contains(target)) return;

            if ((target as HTMLElement).closest('.thrive-modal')) return;

            onHideElement();
        };

        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, [elementShowing, popoutRef, onHideElement]);
};
